import React from 'react'
import styled from 'styled-components';
import {colours} from '../Styles';
import PDLineBreak from './PDLineBreak';
import ContactItem from './ContactItem';
import {icons} from '../img/Icons';
import FooterItem from './FooterItem';
import { Link } from "react-router-dom";

function Footer() {
    const {dark, light, transpLight} = colours;
    const {instagram, facebook} = icons;
    const Footer = styled.div`
        width: 100%;
        min-height: 200px;
        background: ${dark};
        color: ${light};
        display: flex;
        flex-direction: column;
        align-items: center;
        }
        .footer-content {
            width: 70%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
        .social-links {
            width: 80%;
            display: flex;
            justify-content: flex-end;
        }
        .line {
            width: 200px;
            height: 1px;
            background: ${light};
        }
        a {
            transition: 500ms;
        }
        a:hover {
            color: ${transpLight};
        }

        @media only screen and (max-width: 600px) {
            .footer-content {
                width: 95%;
            }
            .spacer {
                width: 100%;
                height: 40px;
                background: ${dark};
            }
        }
    `;
    return (
        <Footer>
            <PDLineBreak colour={light}/>
            <div className="footer-content">
                <FooterItem title="Links">
                    <div className="line"></div>
                    <br/>
                    <Link to="/services">
                        Our Services
                    </Link>
                    <br/><br/>
                    <Link to="/book">
                        Book Appointment
                    </Link>
                    <br/><br/>
                    <Link to="/about">
                        About our Process
                    </Link>
                </FooterItem>
                <FooterItem title="Contact Us">
                    <div className="line"></div>
                    <br/>
                    <a href="tel:647-973-3714">
                        Call/Text
                        <br/>
                        647-973-3714
                    </a>
                    <br/>
                    <br/>
                    <a href="mailto:precisiondetailgta@gmail.com">
                        Email
                        <br/>
                        precisiondetailgta@gmail.com
                    </a>
                </FooterItem>
            </div>
            <div className="social-links">
                <ContactItem icon={instagram} content="" url="https://www.instagram.com/precisiondetailgta/"/>
                <ContactItem icon={facebook} content="" url="#"/>
            </div>
            <div className="spacer"></div>
        </Footer>
    )
}

export default Footer;